



























































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'

@Component({
  components: {
    PageTitle
  }
})
export default class SelectFieldSearch extends Vue {
  private word: string = this.$store.state.plantState.fieldSearchText

  @Prop() private count!: number

  private get changeSearchText (): boolean {
    return this.$store.state.plantState.fieldSearchText
  }
  @Watch('changeSearchText')
  getSearchText (word: string) {
    this.word = word
  }

  private doMasterFieldSearch () {
    this.$store.commit('plantState/setFieldSearchText', this.word)

    this.$emit('search-list')
  }

  private doClear () {
    this.word = ''

    /* stateリセット */
    this.$store.commit('plantState/setFieldSearchText', this.word)

    this.$emit('reset-list')
  }
}
